import AiAgentIcon from '@atlaskit/icon/core/ai-agent';
import AiChatIcon from '@atlaskit/icon/core/ai-chat';
import AiGenerativeTextSummaryIcon from '@atlaskit/icon/core/ai-generative-text-summary';
import AlertIcon from '@atlaskit/icon/core/alert';
import AngleBracketsIcon from '@atlaskit/icon/core/angle-brackets';
import ArchiveBoxIcon from '@atlaskit/icon/core/archive-box';
import AutomationIcon from '@atlaskit/icon/core/automation';
import BacklogIcon from '@atlaskit/icon/core/backlog';
import BoardIcon from '@atlaskit/icon/core/board';
import BookWithBookmarkIcon from '@atlaskit/icon/core/book-with-bookmark';
import BranchIcon from '@atlaskit/icon/core/branch';
import BriefcaseIcon from '@atlaskit/icon/core/briefcase';
import BugIcon from '@atlaskit/icon/core/bug';
import CalendarIcon from '@atlaskit/icon/core/calendar';
import CameraIcon from '@atlaskit/icon/core/camera';
import ChangesIcon from '@atlaskit/icon/core/changes';
import ChartBarIcon from '@atlaskit/icon/core/chart-bar';
import ChartBubbleIcon from '@atlaskit/icon/core/chart-bubble';
import ChartMatrixIcon from '@atlaskit/icon/core/chart-matrix';
import ChartTrendIcon from '@atlaskit/icon/core/chart-trend';
import CheckCircleIcon from '@atlaskit/icon/core/check-circle';
import CheckMarkIcon from '@atlaskit/icon/core/check-mark';
import CheckboxCheckedIcon from '@atlaskit/icon/core/checkbox-checked';
import ClockIcon from '@atlaskit/icon/core/clock';
import CloudArrowUpIcon from '@atlaskit/icon/core/cloud-arrow-up';
import CommentIcon from '@atlaskit/icon/core/comment';
import DataFlowIcon from '@atlaskit/icon/core/data-flow';
import DecisionIcon from '@atlaskit/icon/core/decision';
import DepartmentIcon from '@atlaskit/icon/core/department';
import EditIcon from '@atlaskit/icon/core/edit';
import EmojiIcon from '@atlaskit/icon/core/emoji';
import EyeOpenIcon from '@atlaskit/icon/core/eye-open';
import FeedbackIcon from '@atlaskit/icon/core/feedback';
import FieldCheckboxGroupIcon from '@atlaskit/icon/core/field-checkbox-group';
import FileIcon from '@atlaskit/icon/core/file';
import FilesIcon from '@atlaskit/icon/core/files';
import FlagIcon from '@atlaskit/icon/core/flag';
import FormsIcon from '@atlaskit/icon/core/form';
import GoalIcon from '@atlaskit/icon/core/goal';
import GridIcon from '@atlaskit/icon/core/grid';
import InformationIcon from '@atlaskit/icon/core/information';
import LightbulbIcon from '@atlaskit/icon/core/lightbulb';
import ListBulletedIcon from '@atlaskit/icon/core/list-bulleted';
import ListChecklistIcon from '@atlaskit/icon/core/list-checklist';
import LobbyBellIcon from '@atlaskit/icon/core/lobby-bell';
import LocationIcon from '@atlaskit/icon/core/location';
import MagicWandIcon from '@atlaskit/icon/core/magic-wand';
import MarketplaceIcon from '@atlaskit/icon/core/marketplace';
import MegaphoneIcon from '@atlaskit/icon/core/megaphone';
import ObjectiveIcon from '@atlaskit/icon/core/objective';
import OfficeBuildingIcon from '@atlaskit/icon/core/office-building';
import OperationsIcon from '@atlaskit/icon/core/operations';
import PageIcon from '@atlaskit/icon/core/page';
import PagesIcon from '@atlaskit/icon/core/pages';
import PeopleGroupIcon from '@atlaskit/icon/core/people-group';
import PersonIcon from '@atlaskit/icon/core/person';
import PersonAddIcon from '@atlaskit/icon/core/person-add';
import PersonAddedIcon from '@atlaskit/icon/core/person-added';
import PhoneIcon from '@atlaskit/icon/core/phone';
import PremiumIcon from '@atlaskit/icon/core/premium';
import PresenterModeIcon from '@atlaskit/icon/core/presenter-mode';
import PriorityMajorIcon from '@atlaskit/icon/core/priority-major';
import ProjectIcon from '@atlaskit/icon/core/project';
import RoadmapIcon from '@atlaskit/icon/core/roadmap';
import ScreenIcon from '@atlaskit/icon/core/screen';
import SearchIcon from '@atlaskit/icon/core/search';
import ShareIcon from '@atlaskit/icon/core/share';
import ShowMoreVerticalIcon from '@atlaskit/icon/core/show-more-vertical';
import SmartLinkListIcon from '@atlaskit/icon/core/smart-link-list';
import StarStarredIcon from '@atlaskit/icon/core/star-starred';
import TagIcon from '@atlaskit/icon/core/tag';
import TaskInProgressIcon from '@atlaskit/icon/core/task-in-progress';
import TeamsIcon from '@atlaskit/icon/core/teams';
import TimelineIcon from '@atlaskit/icon/core/timeline';
import TransitionIcon from '@atlaskit/icon/core/transition';
import VideoIcon from '@atlaskit/icon/core/video';
import WarningIcon from '@atlaskit/icon/core/warning';
import WorkItemsIcon from '@atlaskit/icon/core/work-items';
import AssetsGraphIcon from '@atlaskit/icon-lab/core/assets-graph';
import BrowserExtensionIcon from '@atlaskit/icon-lab/core/browser-extension';
import NotepadIcon from '@atlaskit/icon-lab/core/notepad';
import PageLiveDocIcon from '@atlaskit/icon-lab/core/page-live-doc';
import RoadmapsPlanIcon from '@atlaskit/icon-lab/core/roadmaps-plan';
import RovoIcon from '@atlaskit/icon-lab/core/rovo';
import SyncIcon from '@atlaskit/icon-lab/core/sync';
import TextAudioTranscriptIcon from '@atlaskit/icon-lab/core/text-audio-transcript';
import ViewsIcon from '@atlaskit/icon-lab/core/views';

interface IconMapping {
	[key: string]: {
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
		component: any;
		version: 'glyph' | 'core';
	};
}

export const iconMapping: IconMapping = {
	AiGenerativeTextSummaryIcon: {
		component: AiGenerativeTextSummaryIcon,
		version: 'core',
	},
	AssetsGraphIcon: {
		component: AssetsGraphIcon,
		version: 'core',
	},
	ClockIcon: {
		component: ClockIcon,
		version: 'core',
	},
	RovoIcon: {
		component: RovoIcon,
		version: 'core',
	},
	TextAudioTranscriptIcon: {
		component: TextAudioTranscriptIcon,
		version: 'core',
	},
	TimelineIcon: {
		component: TimelineIcon,
		version: 'core',
	},
	CalendarIcon: {
		component: CalendarIcon,
		version: 'core',
	},
	CameraIcon: {
		component: CameraIcon,
		version: 'core',
	},
	WarningIcon: {
		component: WarningIcon,
		version: 'core',
	},
	TeamsIcon: {
		component: TeamsIcon,
		version: 'core',
	},
	ChangesIcon: {
		component: ChangesIcon,
		version: 'core',
	},
	ChartBarIcon: {
		component: ChartBarIcon,
		version: 'core',
	},
	BriefcaseIcon: {
		component: BriefcaseIcon,
		version: 'core',
	},
	AutomationIcon: {
		component: AutomationIcon,
		version: 'core',
	},
	BugIcon: {
		component: BugIcon,
		version: 'core',
	},
	DepartmentIcon: {
		component: DepartmentIcon,
		version: 'core',
	},
	EyeOpenIcon: {
		component: EyeOpenIcon,
		version: 'core',
	},
	BranchIcon: {
		component: BranchIcon,
		version: 'core',
	},
	PhoneIcon: {
		component: PhoneIcon,
		version: 'core',
	},
	PremiumIcon: {
		component: PremiumIcon,
		version: 'core',
	},
	CommentIcon: {
		component: CommentIcon,
		version: 'core',
	},
	Page: {
		component: PageIcon,
		version: 'core',
	},
	PageIcon: {
		component: PageIcon,
		version: 'core',
	},
	PersonAddIcon: {
		component: PersonAddIcon,
		version: 'core',
	},
	PersonAddedIcon: {
		component: PersonAddedIcon,
		version: 'core',
	},
	LobbyBellIcon: {
		component: LobbyBellIcon,
		version: 'core',
	},
	LocationIcon: {
		component: LocationIcon,
		version: 'core',
	},
	InformationIcon: {
		component: InformationIcon,
		version: 'core',
	},
	PriorityMajorIcon: {
		component: PriorityMajorIcon,
		version: 'core',
	},
	OfficeBuildingIcon: {
		component: OfficeBuildingIcon,
		version: 'core',
	},
	ChartTrendIcon: {
		component: ChartTrendIcon,
		version: 'core',
	},
	CheckboxCheckedIcon: {
		component: CheckboxCheckedIcon,
		version: 'core',
	},
	GoalIcon: {
		component: GoalIcon,
		version: 'core',
	},
	ScreenIcon: {
		component: ScreenIcon,
		version: 'core',
	},
	BookWithBookmarkIcon: {
		component: BookWithBookmarkIcon,
		version: 'core',
	},
	PagesIcon: {
		component: PagesIcon,
		version: 'core',
	},
	ChartMatrixIcon: {
		component: ChartMatrixIcon,
		version: 'core',
	},
	RoadmapIcon: {
		component: RoadmapIcon,
		version: 'core',
	},
	ShowMoreVerticalIcon: {
		component: ShowMoreVerticalIcon,
		version: 'core',
	},
	TagIcon: {
		component: TagIcon,
		version: 'core',
	},
	MarketplaceIcon: {
		component: MarketplaceIcon,
		version: 'core',
	},
	AngleBracketsIcon: {
		component: AngleBracketsIcon,
		version: 'core',
	},
	ProjectIcon: {
		component: ProjectIcon,
		version: 'core',
	},
	BoardIcon: {
		component: BoardIcon,
		version: 'core',
	},
	MegaphoneIcon: {
		component: MegaphoneIcon,
		version: 'core',
	},
	TransitionIcon: {
		component: TransitionIcon,
		version: 'core',
	},
	VideoIcon: {
		component: VideoIcon,
		version: 'core',
	},
	StarStarredIcon: {
		component: StarStarredIcon,
		version: 'core',
	},
	EmojiIcon: {
		component: EmojiIcon,
		version: 'core',
	},

	TaskInProgressIcon: {
		component: TaskInProgressIcon,
		version: 'core',
	},
	FormsIcon: {
		component: FormsIcon,
		version: 'core',
	},
	FilesIcon: {
		component: FilesIcon,
		version: 'core',
	},
	FlagIcon: {
		component: FlagIcon,
		version: 'core',
	},
	FileIcon: {
		component: FileIcon,
		version: 'core',
	},
	ListBulletedIcon: {
		component: ListBulletedIcon,
		version: 'core',
	},
	SmartLinkListIcon: {
		component: SmartLinkListIcon,
		version: 'core',
	},
	MagicWandIcon: {
		component: MagicWandIcon,
		version: 'core',
	},
	OperationsIcon: {
		component: OperationsIcon,
		version: 'core',
	},
	DecisionIcon: {
		component: DecisionIcon,
		version: 'core',
	},
	FeedbackIcon: {
		component: FeedbackIcon,
		version: 'core',
	},
	ObjectiveIcon: {
		component: ObjectiveIcon,
		version: 'core',
	},
	PresenterModeIcon: {
		component: PresenterModeIcon,
		version: 'core',
	},
	BacklogIcon: {
		component: BacklogIcon,
		version: 'core',
	},
	SearchIcon: {
		component: SearchIcon,
		version: 'core',
	},
	EditIcon: {
		component: EditIcon,
		version: 'core',
	},
	CheckMarkIcon: {
		component: CheckMarkIcon,
		version: 'core',
	},
	CheckCircleIcon: {
		component: CheckCircleIcon,
		version: 'core',
	},
	ListChecklistIcon: {
		component: ListChecklistIcon,
		version: 'core',
	},
	ArchiveBoxIcon: {
		component: ArchiveBoxIcon,
		version: 'core',
	},
	AlertIcon: {
		component: AlertIcon,
		version: 'core',
	},
	RoadmapsPlanIcon: {
		component: RoadmapsPlanIcon,
		version: 'core',
	},
	PeopleGroupIcon: {
		component: PeopleGroupIcon,
		version: 'core',
	},
	BrowserExtensionIcon: {
		component: BrowserExtensionIcon,
		version: 'core',
	},
	SyncIcon: {
		component: SyncIcon,
		version: 'core',
	},
	NotepadIcon: {
		component: NotepadIcon,
		version: 'core',
	},
	PageLiveDocIcon: {
		component: PageLiveDocIcon,
		version: 'core',
	},
	AiAgentIcon: {
		component: AiAgentIcon,
		version: 'core',
	},
	AiChatIcon: {
		component: AiChatIcon,
		version: 'core',
	},
	ChartBubbleIcon: {
		component: ChartBubbleIcon,
		version: 'core',
	},
	CloudArrowUpIcon: {
		component: CloudArrowUpIcon,
		version: 'core',
	},
	DataFlowIcon: {
		component: DataFlowIcon,
		version: 'core',
	},
	FieldCheckboxGroupIcon: {
		component: FieldCheckboxGroupIcon,
		version: 'core',
	},
	GridIcon: {
		component: GridIcon,
		version: 'core',
	},
	LightbulbIcon: {
		component: LightbulbIcon,
		version: 'core',
	},
	PersonIcon: {
		component: PersonIcon,
		version: 'core',
	},
	ShareIcon: {
		component: ShareIcon,
		version: 'core',
	},
	WorkItemsIcon: {
		component: WorkItemsIcon,
		version: 'core',
	},
	ViewsIcon: {
		component: ViewsIcon,
		version: 'core',
	},
} as const;

export type IconNames = keyof typeof iconMapping;
